<script setup>
import AddNewCourse from "./AddNewCourse.vue";
import AllCourses from "./AllCourses.vue";
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <AddNewCourse />
          <AllCourses />
        </div>
      </div>
    </div>
    <canvas id="imageCanvas" style="display: none"></canvas>
  </section>
</template>
